import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {
  }

  /**
   * Retrieves the value associated with the given key from local storage.
   *
   * @param key The key corresponding to the desired item in local storage.
   * @return The value associated with the given key if it exists, or null if the key is not found.
   */
  public getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  /**
   * Stores a key-value pair in the local storage.
   *
   * @param key The key associated with the value to be stored.
   * @param value The value to be stored in local storage.
   * @return void
   */
  public setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  /**
   * Removes an item from the local storage associated with the provided key.
   *
   * @param {string} key - The key corresponding to the item to be removed from local storage.
   * @return {void} This method does not return a value.
   */
  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
